import { HStack, Pressable, VStack, Box } from 'native-base';
import React, { ReactNode, useState } from 'react';
import { Caption } from './Typography';
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { SpIcon } from './Icon';
import { useTheme } from '@springbig/shared';

export type SBDropdownProp = {
    title?: string;
    children?: ReactNode;
    defaultShowChildren?: boolean;
    value?: string | number;
};

export const SBDropdown = ({
    title,
    children,
    defaultShowChildren = false,
    value,
}: SBDropdownProp) => {

    const {
        radius_sm,
        primary,
        background_secondary,
        highlight_text,
        text
    } = useTheme();

    const [showChildren, setShowChildren] = useState(defaultShowChildren);

    return (
        <Box w={'100%'}>
            <HStack alignItems={'center'} justifyContent={'space-between'}>
                <Pressable
                    onPress={() => setShowChildren(!showChildren)}
                    bg={background_secondary}
                    px={4}
                    borderTopLeftRadius={radius_sm}
                    borderBottomLeftRadius={showChildren ? 0 : radius_sm}
                    flex={1}
                    size={8}
                    justifyContent={'center'}
                >
                    <Caption color={value ? highlight_text : text }>
                        { value ? value : title }
                    </Caption>
                </Pressable>
                <Pressable
                    onPress={() => setShowChildren(!showChildren)}
                    bg={background_secondary}
                    px={2}
                    justifyContent={'center'}
                    borderTopRightRadius={radius_sm}
                    borderBottomRightRadius={showChildren ? 0 : radius_sm}
                    size={8}
                >
                    <SpIcon
                        icon={showChildren ? faAngleUp : faAngleDown}
                        color={primary}
                    />
                </Pressable>
            </HStack>
            { showChildren ?
                <Box
                    borderBottomRadius={radius_sm}
                    borderColor={background_secondary}
                    borderWidth={1}
                    py={2}
                    pl={2}
                >
                    {/* use mr={-2} on FlatList to cancel out the padding right */}
                    {/* and have a scrollbar flush with the right side */}
                    <Box pr={2} overflowY={'auto'}>
                        { children }
                    </Box>
                </Box>
                :
                <></>
            }
        </Box>
    );
};
